module.exports = __webpack_public_path__ + "static/media/success_message.f11efb51.png";